export const SENTRY_DNS =
  'https://b4bddfd2376e8b448c3d819facd509ce@o1082595.ingest.us.sentry.io/4507493691883520'
export const SENTRY_PROJECT = 'wellesley-web'
export const SENTRY_AUTH_TOKEN =
  '1d93ff28a44e4c3aaaaff854277cd8583c1de670bd8744bc895670dfd9300840'
